import React from "react"

import imgReciclaje from "./../../../assets/images/packaging-delivery/img_reciclaje.png"
import imgEmpaques from "./../../../assets/images/packaging-delivery/empaques.png"

import "./packaging-delivery-section-1.scss"

function PackagingDeliverySection1() {
  return (
    <div className="f-packaging-delivery-section-1">
      <div className="f-packaging-delivery-section-1__container-1">
        <img
          className="f-packaging-delivery-section-1__container-1__img"
          src={imgReciclaje}
          alt="Referente: Empaque de toallas transformado en sillas de parques"
        />
        <p className="f-packaging-delivery-section-1__container-1__paragraph">
          Con tu ayuda,{" "}
          <span className="f-packaging-delivery-section-1__container-1__paragraph__span--bold f-packaging-delivery-section-1__container-1__paragraph__span--pink">
            Nosotras
          </span>{" "}
          <span className="f-packaging-delivery-section-1__container-1__paragraph__span--yellow-fill f-packaging-delivery-section-1__container-1__paragraph__span--pink">
            Reciclamos, reducimos y reutilizamos
          </span>{" "}
          por un planeta más sostenible.
          <br />
          <span className="f-packaging-delivery-section-1__container-1__paragraph__span--pink f-packaging-delivery-section-1__container-1__paragraph__span--18">
            Estamos listas para darle más Loving al planeta ¡y contigo vamos a
            lograrlo!
          </span>
        </p>
      </div>
      <div className="f-packaging-delivery-section-1__container-2">
        <p className="f-packaging-delivery-section-1__container-2__text-1">
          ¿Recuerdas los empaques Nosotras que has guardado para redimir tus
          puntos?
        </p>

        <p className="f-packaging-delivery-section-1__container-2__text-2">
          Es hora de darles una nueva vida convirtiéndolos en cuadernos, parques
          infantiles, mangueras, estibas, viveros, sillas y muchos elementos
          más.
        </p>
        <p className="f-packaging-delivery-section-1__container-2__text-3">
          La clave para lograrlo <b>Serás tú</b>
        </p>
        <img
          src={imgEmpaques}
          alt="Referente: variedad de empaques Nosotras"
          className="f-packaging-delivery-section-1__container-2__img"
        />
      </div>
    </div>
  )
}

export default PackagingDeliverySection1
